/**
  Selects all elements with the attribute js-other-sodas-comparison.
  For each element, it initializes a toggle button that changes the displayed content of a comparison table
  between two different products: olipop and soda.
*/

export const buildOtherSodaComparison = () => {
  const elements = document.querySelectorAll("[js-other-sodas-comparison]");
  elements.forEach((element) => {
    const displayedProduct = "olipop";
    const toggleBtn = element.querySelector(".other-sodas-comparison--toggle");
    const toggleSpan = element.querySelector(".other-sodas-toggle--button");
    function displayProduct(product) {
      const details = element.querySelectorAll(
        '[class^="other-sodas-comparison__details"]'
      );
      details.forEach((detail) => {
        detail.classList.remove("animate__fadeIn");
      });
      element
        .querySelector(`.other-sodas-comparison__details-${product}`)
        .classList.toggle("animate__fadeIn");
      if (product === "olipop") {
        toggleSpan.style.right = "auto";
        toggleBtn.setAttribute("aria-checked", "true");
      } else {
        toggleSpan.style.right = "0";
        toggleBtn.setAttribute("aria-checked", "false");
      }
    }

    displayProduct(displayedProduct);

    toggleBtn.addEventListener("click", function (event) {
      let newProduct = "";
      if (displayedProduct === "olipop") {
        newProduct = "soda";
      } else {
        newProduct = "olipop";
      }
      displayProduct(newProduct);
      displayedProduct = newProduct;
    });
  });
};
